var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaginationTransitionSlide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6216 4C14.9772 4.39724 15.23 4.89232 15.334 5.44714L16.834 13.4471C17.0146 14.4102 16.7155 15.3353 16.1215 16H16.5903C17.8426 16 18.7868 14.8623 18.556 13.6314L17.056 5.63142C16.8787 4.68548 16.0527 4 15.0903 4H14.6216Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6216 4C11.9772 4.39724 12.23 4.89232 12.334 5.44714L13.834 13.4471C14.0146 14.4102 13.7155 15.3353 13.1215 16H13.5903C14.8426 16 15.7868 14.8623 15.556 13.6314L14.056 5.63142C13.8787 4.68548 13.0527 4 12.0903 4H11.6216Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5901 16H4.90985C3.94742 16 3.12147 15.3145 2.94411 14.3686L1.44411 6.36858C1.21333 5.13775 2.15758 4 3.40985 4H9.09015C10.0526 4 10.8785 4.68548 11.0559 5.63142L12.5559 13.6314C12.7867 14.8623 11.8424 16 10.5901 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaginationTransitionSlide);
export default __webpack_public_path__ + "static/media/icon-pagination-transition-slide.332baf538942dbe217a4e63a2c7daf7e.svg";
export { ForwardRef as ReactComponent };